import {useQuery} from "@tanstack/react-query";
import {programsUrl} from "../../constants/api/soft-user/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";

interface GetProgramsParams {
  institution_id?: string,
  portfolio_id?: string | null,
  program_id?: string,
  searchValue?: string,
  sortingValue?: string,
  name_only?: boolean,
  current_page?: number,
  filter?: string,
  userIsSoft?: boolean,
  paid?: boolean
  only_current_submission_courses?: boolean,
  show_recommended?: boolean
}

export const useQueryPrograms = (params: GetProgramsParams) => {
  const {
    institution_id,
    portfolio_id,
    program_id,
    searchValue,
    sortingValue,
    name_only,
    current_page,
    filter,
    userIsSoft,
    paid,
    only_current_submission_courses,
    show_recommended
  } = params;

  const axios = useAxios();

  const handleRequest = () => {
    const queryParams: Record<string, any> = {
      institution_id,
      portfolio_id,
      program_id,
      search_term: searchValue,
      ordering: sortingValue,
      name_only,
      current_page,
      paid,
      only_current_submission_courses,
      show_recommended
    };

    if (filter) {
      queryParams.filter = filter;
    }

    return axios.get(programsUrl(userIsSoft), {params: queryParams})
      .then(response => {
        if (program_id) {
          return {
            ...response?.data?.programs[0],
            catalogue_url: response?.data.catalogue_url
          };
        } else if (name_only) {
          return response?.data?.programs ?? response;
        } else {
          return response?.data ?? response;
        }
      });
  }

  return useQuery({queryKey: ['programs', params], queryFn: handleRequest});
};
